/* eslint-disable no-unused-vars */
import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomInputDecimal } from 'src/components'
import {
  salePriceCurrency,
  purchasePriceCurrency,
  setBrokerageSalePriceCurrency,
  setBrokeragePurchasePriceCurrency,
} from 'src/features'


const AcquisitionPrices: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const purchasePriceCurrencyValue = useAppSelector(purchasePriceCurrency)
  const salePriceCurrencyValue = useAppSelector(salePriceCurrency)

  const handleCurrencyChange = (type: string) => (value: string) => {
    if (type === 'SALE_PRICE') dispatch(setBrokerageSalePriceCurrency(value))
    else dispatch(setBrokeragePurchasePriceCurrency(value))
  }

  return <>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('admin.Brokerage.PurchasePrice')}
          subtitle={t('general.RequiredField')}
        />
      </CustomCol>
      <CustomCol>
        <CustomInputDecimal
          name={'purhcasePrice'}
          placeholder={t('admin.Brokerage.PurchasePricePlaceHolder')}
          defautlCurrencyValue={purchasePriceCurrencyValue}
          handleCurrencyChange={handleCurrencyChange('PURCHASE_PRICE')}
          required
          hasCurrency
        />
      </CustomCol>
    </Row>

    {/* Prucahse Price */}
    <Row>
      <CustomCol>
        <FormLabels
          title={t('admin.Brokerage.SalePrice')}
          subtitle={t('general.RequiredField')}
        />
      </CustomCol>
      <CustomCol>
        <CustomInputDecimal
          name={'salePrice'}
          placeholder={t('admin.Brokerage.SalePricePlaceHolder')}
          defautlCurrencyValue={salePriceCurrencyValue}
          handleCurrencyChange={handleCurrencyChange('SALE_PRICE')}
          required
          hasCurrency
        />
      </CustomCol>
    </Row>
  </>
}

export default AcquisitionPrices
